<template>
    <div class="DocumentEditor">
        
        <b-modal ref="component-modal" :title="ModalTitle" size="sm"  @shown="HandleShown()" hide-footer >
            <b-container>
                <b-form @submit="Save">
                    <div class="form-group">
                        <label>Password:</label>
                        <input type="password" v-model="Password" ref="showfocus" class="form-control" required/>
                    </div>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="Cancel()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit" >
                                <font-awesome-icon :icon="['fa', 'signature']" />
                                SIGN
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </div>

</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSignature } from '@fortawesome/free-solid-svg-icons';
    library.add(faSignature);



    export default {
        props: [
            "ModalTitle",
        ],
        data: function () {
            return {
                Password: "",
            }
        },
        methods: {
            Save: function (e) {
                e.preventDefault();
                this.$refs['component-modal'].hide();
                this.$emit('passwordentered', this.Password)

            },
            ShowModal: function () {
                this.Password = "";
                this.$refs['component-modal'].show();
            },
            Cancel() {
                this.$refs['component-modal'].hide();
            },
            HandleShown() {
                this.$refs.showfocus.focus();
            }
            
        },
        components: {
            
        },
        computed: {

        },
        mounted: function () {
            
        }
    }
</script>

<style scoped>

</style>